export const getTreeSpeciesText = (speciesKey: string, t: (key: string) => string): string => {
    switch (speciesKey) {
        case 'Løv':
            return t('stackDialog.deciduous');
        case 'Nål':
            return t('stackDialog.coniferous');
        case 'Blandet':
            return t('stackDialog.mixed');
        case 'Pil/poppel':
            return t('stackDialog.willowPoplar');
        default:
            return speciesKey;
    }
};
